//零星采购管理
export default [
//  分包价格管理
//  工程工序编码管理

{
  path: 'engineeringImport',
  name: 'engineeringImport',
  component: function component() {
    return import('@/views/subpackageManage/engineering/import');
  }
}, {
  path: 'engineeringIist',
  name: 'engineeringIist',
  component: function component() {
    return import('@/views/subpackageManage/engineering/list');
  }
},
// 分包价格信息
{
  path: 'buildingPriceeAdd',
  name: 'buildingPriceeAdd',
  component: function component() {
    return import('@/views/subpackageManage/buildingPrice/add');
  }
}, {
  path: 'buildingPriceDetail',
  name: 'buildingPriceDetail',
  component: function component() {
    return import('@/views/subpackageManage/buildingPrice/detail');
  }
}, {
  path: 'buildingPriceEdit',
  name: 'buildingPriceEdit',
  component: function component() {
    return import('@/views/subpackageManage/buildingPrice/edit');
  }
}, {
  path: 'buildingPriceSuccess',
  name: 'buildingPriceSuccess',
  component: function component() {
    return import('@/views/subpackageManage/buildingPrice/success');
  }
}, {
  path: 'buildingPriceImport',
  name: 'buildingPriceImport',
  component: function component() {
    return import('@/views/subpackageManage/buildingPrice/import');
  }
}, {
  path: 'buildingPriceList',
  name: 'buildingPriceList',
  component: function component() {
    return import('@/views/subpackageManage/buildingPrice/list');
  }
},
// 分包价格信息台账
{
  path: 'subpackageManage',
  name: 'subpackageManage',
  component: function component() {
    return import('@/views/subpackageManage');
  }
}];